// extracted by mini-css-extract-plugin
export default {"content":"Header_content__Y9tv4","title":"Header_title__rzFD1","nullPoint":"Header_nullPoint__SDBvg"};